module.exports = __webpack_public_path__ + "static/media/smallTarget.ef55f615.svg";